module.exports = __webpack_public_path__ + "img/im the strongest.0025ecbe.png";